<div class="gsi" [class.gsi--open]="isOpen">
  <!-- Pill input — matches create-contact .cf-input -->
  <div class="gsi__bar">
    <svg class="gsi__bar-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
    </svg>
    <input
      #searchInput
      type="text"
      class="gsi__input"
      [(ngModel)]="query"
      (ngModelChange)="onQueryChange()"
      (focus)="openPanel()"
      [placeholder]="'GLOBAL_SEARCH.PLACEHOLDER' | translate"
      role="combobox"
      aria-autocomplete="list"
      [attr.aria-expanded]="isOpen"
      aria-controls="gsp-listbox"
      [attr.aria-activedescendant]="isOpen ? 'gsp-option-' + activeIndex : null"
      [attr.aria-keyshortcuts]="isMac ? 'Meta+K' : 'Control+K'"
      autocomplete="off"
      spellcheck="false"
    />
    <span *ngIf="!isOpen" class="gsi__kbd" aria-hidden="true">
      {{ isMac ? "⌘" : "Ctrl" }}&nbsp;K
    </span>
    <button
      *ngIf="isOpen"
      type="button"
      class="gsi__esc"
      (mousedown)="$event.preventDefault()"
      (click)="close()"
      [attr.aria-label]="'GLOBAL_SEARCH.TO_CLOSE' | translate"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true">
        <path d="M18 6 6 18M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Panel — matches header notification dropdown -->
  <div *ngIf="isOpen" class="gsi__panel" role="dialog" [attr.aria-label]="'GLOBAL_SEARCH.TRIGGER' | translate">
    <div class="gsi__panel-header">
      <div class="gsi__panel-title">
        <h3>{{ "GLOBAL_SEARCH.TRIGGER" | translate }}</h3>
        <span *ngIf="query.trim() && flat.length" class="gsi__panel-count">{{ flat.length }}</span>
      </div>
      <button
        type="button"
        class="gsi__panel-close"
        (mousedown)="$event.preventDefault()"
        (click)="close()"
        [attr.aria-label]="'GLOBAL_SEARCH.TO_CLOSE' | translate"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="gsp__body" id="gsp-listbox" role="listbox">
      <ng-container *ngIf="!query.trim()">
        <div *ngIf="recent.length" class="gsp__group">
          <div class="gsp__group-head">
            <span class="gsp__group-title">{{ "GLOBAL_SEARCH.RECENT" | translate }}</span>
            <button type="button" class="gsp__clear" (click)="clearRecent($event)">
              {{ "GLOBAL_SEARCH.CLEAR" | translate }}
            </button>
          </div>
          <button
            *ngFor="let item of recent; let i = index; trackBy: trackByPath"
            type="button"
            class="gsp__option"
            role="option"
            [id]="'gsp-option-' + i"
            [class.gsp__option--active]="activeIndex === i"
            [attr.aria-selected]="activeIndex === i"
            (mouseenter)="activeIndex = i"
            (mousedown)="$event.preventDefault()"
            (click)="go(item.path, item)"
          >
            <span class="gsp__option-icon gsp__option-icon--recent" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /><path d="M12 7v5l4 2" />
              </svg>
            </span>
            <span class="gsp__option-main">
              <span class="gsp__option-label">{{ item.label }}</span>
              <span class="gsp__option-meta">
                {{ item.description || ("GLOBAL_SEARCH.DESC_DEFAULT" | translate) }}
              </span>
            </span>
          </button>
        </div>

        <div *ngIf="defaultPageEntries.length" class="gsp__group">
          <div class="gsp__group-head">
            <span class="gsp__group-title">{{ "GLOBAL_SEARCH.PAGES" | translate }}</span>
          </div>
          <button
            *ngFor="let item of defaultPageEntries; let i = index; trackBy: trackByPath"
            type="button"
            class="gsp__option"
            role="option"
            [id]="'gsp-option-' + (recent.length + i)"
            [class.gsp__option--active]="activeIndex === recent.length + i"
            [attr.aria-selected]="activeIndex === recent.length + i"
            (mouseenter)="activeIndex = recent.length + i"
            (mousedown)="$event.preventDefault()"
            (click)="go(item.path, item)"
          >
            <span class="gsp__option-icon" aria-hidden="true">
              <app-sidebar-icon [name]="item.icon" [size]="16" [strokeWidth]="1.8"></app-sidebar-icon>
            </span>
            <span class="gsp__option-main">
              <span class="gsp__option-label">{{ item.label }}</span>
              <span class="gsp__option-meta">
                {{ item.description || ("GLOBAL_SEARCH.DESC_DEFAULT" | translate) }}
              </span>
            </span>
          </button>
        </div>

        <div *ngIf="quickActionEntries.length" class="gsp__group">
          <div class="gsp__group-head">
            <span class="gsp__group-title">{{ "GLOBAL_SEARCH.QUICK_ACTIONS" | translate }}</span>
          </div>
          <button
            *ngFor="let item of quickActionEntries; let i = index; trackBy: trackByPath"
            type="button"
            class="gsp__option"
            role="option"
            [id]="'gsp-option-' + (recent.length + defaultPageEntries.length + i)"
            [class.gsp__option--active]="activeIndex === recent.length + defaultPageEntries.length + i"
            [attr.aria-selected]="activeIndex === recent.length + defaultPageEntries.length + i"
            (mouseenter)="activeIndex = recent.length + defaultPageEntries.length + i"
            (mousedown)="$event.preventDefault()"
            (click)="go(item.path, item)"
          >
            <span class="gsp__option-icon gsp__option-icon--action" aria-hidden="true">
              <app-sidebar-icon [name]="item.icon" [size]="16" [strokeWidth]="1.8"></app-sidebar-icon>
            </span>
            <span class="gsp__option-main">
              <span class="gsp__option-label">{{ item.label }}</span>
              <span class="gsp__option-meta">{{ item.description }}</span>
            </span>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="query.trim()">
        <ng-container *ngIf="groups.length; else gspEmpty">
          <div *ngFor="let group of groups" class="gsp__group">
            <div class="gsp__group-head">
              <span class="gsp__group-title">{{ group.category }}</span>
            </div>
            <button
              *ngFor="let item of group.items; trackBy: trackByPath"
              type="button"
              class="gsp__option"
              role="option"
              [id]="'gsp-option-' + flat.indexOf(item)"
              [class.gsp__option--active]="activeIndex === flat.indexOf(item)"
              [attr.aria-selected]="activeIndex === flat.indexOf(item)"
              (mouseenter)="activeIndex = flat.indexOf(item)"
              (mousedown)="$event.preventDefault()"
              (click)="go(item.path, item)"
            >
              <span class="gsp__option-icon" aria-hidden="true">
                <app-sidebar-icon [name]="item.icon" [size]="16" [strokeWidth]="1.8"></app-sidebar-icon>
              </span>
              <span class="gsp__option-main">
                <span class="gsp__option-label">
                  <ng-container *ngFor="let seg of item.segments">
                    <b *ngIf="seg.hit">{{ seg.text }}</b>
                    <ng-container *ngIf="!seg.hit">{{ seg.text }}</ng-container>
                  </ng-container>
                </span>
                <span class="gsp__option-meta">{{ item.description }}</span>
              </span>
            </button>
          </div>
        </ng-container>

        <ng-template #gspEmpty>
          <div class="gsp__empty">
            <div class="gsp__empty-icon" aria-hidden="true">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /><path d="M8 11h6" />
              </svg>
            </div>
            <p class="gsp__empty-title">
              {{ "GLOBAL_SEARCH.NO_RESULTS" | translate }} “{{ query }}”
            </p>
            <p class="gsp__empty-hint">{{ "GLOBAL_SEARCH.TRY_AGAIN" | translate }}</p>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <footer class="gsi__panel-footer">
      <span class="gsp__hint">
        <kbd>↑</kbd><kbd>↓</kbd> {{ "GLOBAL_SEARCH.TO_NAVIGATE" | translate }}
      </span>
      <span class="gsp__hint">
        <kbd>↵</kbd> {{ "GLOBAL_SEARCH.TO_OPEN" | translate }}
      </span>
      <span class="gsp__hint gsp__hint--end">
        <kbd>esc</kbd> {{ "GLOBAL_SEARCH.TO_CLOSE" | translate }}
      </span>
    </footer>
  </div>
</div>
